import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    padding: theme.spacing(2.5),
    flexDirection: "column",
    width: "100%",
    maxWidth: "320px",
  },
  heading: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "10px",
    width: "100%",
  },
  closeIcon: { cursor: "pointer" },
  actionButton: {
    paddingTop: theme.spacing(1.5),
  },
}));
